import { gql } from '@apollo/client';

export type { DeleteWebhookUrl as IDeleteWebhookUrl } from './__generated__/DeleteWebhookUrl';

export const DELETE_WEBHOOK_URL = gql`
  mutation DeleteWebhookUrl {
    deleteWebhookUrl
  }
`;
